import { render } from "./EditAuthorizedServiceDialog.vue?vue&type=template&id=bbc60b8c&scoped=true"
import script from "./EditAuthorizedServiceDialog.vue?vue&type=script&lang=js"
export * from "./EditAuthorizedServiceDialog.vue?vue&type=script&lang=js"

import "./EditAuthorizedServiceDialog.vue?vue&type=style&index=0&id=bbc60b8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc60b8c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QForm,QSelect,QInput,QCardActions,QSpace});qInstall(script, 'directives', {ClosePopup});
